import Styled from 'styled-components';

export const TaskCardAlert = Styled.p`
  margin-bottom: 1.5em;
  display: block;
  font-size: 1.2rem;
  line-height: 1.5;
  color: ${({ theme: { text } }) => text.colorText};
`;
